import { useMemo } from 'react';

import { useAllEmployees } from '~/data/employees';
import { useOrgUnitHRSupervisor } from '~/data/orgunits/useOrgUnitHRSupervisor';

type UseResponsibleHRSelectOutput = {
  defaultResponsibleHrId: number | undefined;
  allResponsibleHRIds: number[];
  isLoading: boolean;
};

export const useResponsibleHRSelect = (
  employeeId: number,
): UseResponsibleHRSelectOutput => {
  const { allEmployees, isLoading: isAllEmpLoading } = useAllEmployees();

  const orgUnitId: number = useMemo(() => {
    return (
      Object.values(allEmployees).find(
        (employee) => employee.fEmpId === employeeId,
      )?.fEmpUnit || 0
    );
  }, [allEmployees, employeeId]);

  const { data, isLoading: isHRSuperLoading } = useOrgUnitHRSupervisor({
    orgUnitId,
  });

  const isDataLoading = isAllEmpLoading || isHRSuperLoading;

  return {
    defaultResponsibleHrId: !!data && !!data[0] ? data[0] : undefined,
    allResponsibleHRIds: data || [],
    isLoading: isDataLoading,
  };
};
